import { Token } from '@uniswap/sdk-core'
import { ChainId } from '@uniswap/smart-order-router'
import { useMemo } from 'react'

import { USELESS_NFT_ADDRESSES } from '../constants/addresses'
import useActiveWeb3React from './useActiveWeb3React'

export default function useUselessToken(): Token | undefined {
  const { chainId } = useActiveWeb3React()
  return useMemo(() => {
    if (!USELESS_NFT_ADDRESSES[chainId ?? ChainId.MAINNET]) {
      return undefined
    }
    return new Token(
      chainId ?? ChainId.MAINNET,
      USELESS_NFT_ADDRESSES[chainId ?? ChainId.MAINNET],
      0,
      'USELESS',
      'Useless NFT'
    )
  }, [chainId])
}
